var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.style),attrs:{"id":"header"}},[_c('h1',{style:(!_vm.mobile_two_lines && _vm.mobile ? 'margin-top: 10vh' : '')},[_vm._v(_vm._s(_vm.title))]),_c('strong',[_vm._v(_vm._s(_vm.subtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }